<template>
    <v-container class="fill-height login-container" fluid :style="{ backgroundImage: `url(${backgroundImage})` }">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                    <v-toolbar color="secondary">
                        <v-toolbar-title>Login to B-QUAL or BTrace</v-toolbar-title>
                    </v-toolbar>
                    <v-form @submit="login" @submit.prevent="noAction" v-model="valid" ref="form">
                        <v-card-text>
                            <v-text-field label="Email Address" prepend-icon="mdi-account" v-model="emailAddress" type="text" :rules="emailAddressRules" required />
                            <v-text-field label="Password" prepend-icon="mdi-lock" v-model="password" type="password" :rules="passwordRules" required />
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="forgotPassword">Forgot Password</v-btn>
                            <v-spacer />
                            <v-btn role="button" type="submit" :disabled="loggingIn">Login</v-btn>
                            <img v-show="loggingIn" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                valid: true,
                password: '',
                emailAddress: '',
                submitted: false,
                passwordRules: [
                    v => !!v || 'Password is required'
                ],
                emailAddressRules: [
                    v => !!v || 'Email Address is required',
                    v => !(v && v.length > 320) || 'Email Address must be less than 320 characters'
                ],
                backgroundImage: require('../assets/background-logo.svg')
            }
        },
        computed: {
            loggingIn() {
                return this.$store.state.authentication.status.loggingIn;
            }
        },
        methods: {
            login() {
                this.$refs.form.validate();
                if (!this.valid) { return; }

                this.submitted = true;
                const { emailAddress, password } = this;
                const { dispatch } = this.$store;
                dispatch('authentication/login', { emailAddress, password });
            },
            forgotPassword() { // TODO: Implement forgotPassword link
                this.$router.push('/request-reset-password');
            },
            noAction() { }
        }
    };
</script>

<style>
    .login-container {
        background-size: cover;

    }
</style>
